export enum ProposalLayoutDefaultVersionNumber {
  V1 = 1,
}
